function addOrRemoveClassNames(elems, classNames, mustAdd) {

    if (!(elems instanceof Array)){
        elems = [elems];
    }

    if (typeof classNames === 'object'){
        classNames = classNames.join(' ');
    }

    elems.forEach(elem => {
        if (mustAdd){
            elem.classList.add(classNames);
        }else{
            elem.classList.remove(classNames);
        }
    })
}

export const addCl = (elems, classNames) => addOrRemoveClassNames(elems, classNames, true);

export const rmCl = (elems, classNames) => addOrRemoveClassNames(elems, classNames, false);

export const hasCl = (elem, className ) => elem.classList.contains(className);




// WEBPACK FOOTER //
// ./src/js/utils/elementClasses.js